import { useContext } from "react";

import backgroundColorContext from "./backgroundColorContext";
import getVisualColor from "./getVisualColor";

export default function BackgroundColorContextProvider({
  backgroundColor,
  children,
}) {
  let parentBackgroundColor = useContext(backgroundColorContext);
  let visualColor = getVisualColor(parentBackgroundColor, backgroundColor);
  return (
    <backgroundColorContext.Provider value={visualColor}>
      {children}
    </backgroundColorContext.Provider>
  );
}
